import React, { useEffect } from 'react';
import './index.scss';
import ReviewsHeader from '../ReviewsHeader';
import JustifiedData from '../JustifiedData';
import { useFeedsCommentItem } from '../../hooks';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useIntl } from 'umi';
import useReviewReplyData from '@op/components/ReviewsModal/useReviewReplyData';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import CardSentiment from '@op/pages/accounts/widgets/AccountsCard/Sentiment';
const OriginalPost = ({
  id,
  gameInfo,
  commentTime,
  language,
  isShowSentiment,
  data,
  userInfo,
  feedsSource,
}: any) => {
  const { mainItem, loading, getFeedsContents, empty } = useFeedsCommentItem();

  const { Sentiment_Update } = useGetSingePageSourceRule({
    keys: 'Sentiment_Update',
  });

  const { sentimentInfo, loading: sentimentLoading } = useReviewReplyData({
    itemData: data,
    gameInfo,
    userInfo,
    language,
    showSentiment: !Sentiment_Update,
    feedsSource,
  });

  const { formatMessage } = useIntl();

  useEffect(() => {
    const params = {
      comment_ids: [id],
      end_time: commentTime,
      ...gameInfo,
    };
    if (feedsSource) {
      params.feed_source = feedsSource;
    }
    getFeedsContents(params);
  }, [id]);

  return (
    <CardCommon
      contentCard
      loading={sentimentLoading || loading}
      loadingHeight={50}
    >
      {!empty ? (
        <CardSentiment
          sentimentsData={sentimentInfo}
          className="dbo-keywordbox-sentimentbox-border"
        ></CardSentiment>
      ) : (
        <div />
      )}
      <div className="dbo-original-post">
        <div className="dbo-original-post-title">
          {formatMessage({ id: 'Original Post' })}
        </div>
        <CardCommon
          contentCard
          loading={loading}
          empty={empty}
          emptyHeight={50}
          loadingHeight={50}
          hasEmptyDesc={false}
          hasEmptyImg={false}
          hasEmptyTitle={false}
          emptyDescElement={
            <div className="dbo-original-post-nodata">
              {formatMessage({ id: 'This comment has no post.' })}
            </div>
          }
        >
          <div className="dbo-original-post-context">
            <ReviewsHeader
              isShowSentiment={isShowSentiment}
              data={mainItem}
              gameInfo={gameInfo}
              isActive
              language={language}
            />
            <JustifiedData data={mainItem} />
          </div>
        </CardCommon>
      </div>
    </CardCommon>
  );
};

export default OriginalPost;
